import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/components/pets-sale/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/BackButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/buttons/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/call-to-number/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/HiddenLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dogs-blog/dogs-blog/src/shared/ui/theme/index.tsx");
